"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimUpdatePagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var MotorClaim_1 = require("../../model/MotorClaim");
var ClaimsForm_1 = require("./ClaimsForm");
var moment = require("moment");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var RentersClaim_1 = require("../../model/RentersClaim");
var services_1 = require("@falcon/services");
var ClaimUpdatePagePlain = /** @class */ (function (_super) {
    __extends(ClaimUpdatePagePlain, _super);
    function ClaimUpdatePagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.renderBackLink = function () {
            var link = {
                pathname: "/customers/".concat(_this.props.params.customerId, "/claims"),
                state: {
                    selectedDriver: _this.state.selectedDriver
                }
            };
            return _this.supportPortalTemplates.renderBackLink("Claims", true, link);
        };
        _this.state = {
            deleted: false,
            selectedDriver: _this.props.location.state.selectedDriver,
            claimLoaded: false
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        return _this;
    }
    ClaimUpdatePagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.getClaim(this.state.selectedDriver.driverIds[0].toString(), this.props.params.claimId).subscribe(function (claim) { return _this.setState({ claim: claim, claimLoaded: true }); });
    };
    ClaimUpdatePagePlain.prototype.render = function () {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler"])) {
            if (this.state.claimLoaded) {
                if (this.state.claim) {
                    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.renderBackLink(), (0, jsx_runtime_1.jsxs)("div", { className: "row panel-border", children: [(0, jsx_runtime_1.jsxs)("div", { className: "col-12 mb-3", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Claim info" }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("b", { children: "id: " }), this.props.params.claimId] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("b", { children: "Type: " }), SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(this.state.claim) === services_1.ProductsEnum.MOTOR && MotorClaim_1.default.getClaimType(this.state.claim.claimTypeId), SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(this.state.claim) === services_1.ProductsEnum.RENTERS && RentersClaim_1.default.getClaimType(this.state.claim.claimTypeId)] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("b", { children: "Incident date: " }), this.state.claim && moment(this.state.claim.incidentDate).format("DD/MM/YYYY")] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("b", { children: "Any claim spend? " }), this.state.claim ? this.state.claim.anyClaimSpend ? "Yes" : "No" : ""] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("b", { children: "NCD Allowed? " }), this.state.claim ? this.state.claim.refundAllowed ? "Yes" : "No" : ""] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "col-12", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Update claim" }), (0, jsx_runtime_1.jsx)(ClaimsForm_1.ClaimsForm, __assign({ product: SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaimProduct(this.state.claim), onSubmit: this.handleSubmit, submitText: "Update", selectedDriver: this.state.selectedDriver }, this.props))] }), (0, jsx_runtime_1.jsxs)("div", { className: "col-12", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Delete claim" }), (0, jsx_runtime_1.jsx)("button", { className: "btn btn-danger ml-0", type: "button", onClick: this.handleDelete, children: "Delete claim" })] })] })] }));
                }
                else {
                    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.renderBackLink(), (0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsx)("div", { className: "col-12 alert alert-danger", children: "Claim not found" }) })] }));
                }
            }
            else {
                return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
            }
        }
        else {
            return this.supportPortalTemplates.renderErrorPage();
        }
    };
    ClaimUpdatePagePlain.prototype.handleDelete = function () {
        var _this = this;
        if (confirm("Are you sure you want to delete this claim?")) {
            this.supportPortalService.deleteClaim(this.state.selectedDriver.driverIds[0].toString(), this.props.params.claimId).subscribe(function () {
                _this.setState({ deleted: true });
                _this.props.navigate("/customers/".concat(_this.props.params.customerId, "/claims"), {
                    state: {
                        deleted: _this.state.deleted,
                        selectedDriver: _this.state.selectedDriver
                    }
                });
            });
        }
    };
    ClaimUpdatePagePlain.prototype.handleSubmit = function (claimRequest) {
        var _this = this;
        this.supportPortalService.updateClaim(this.state.selectedDriver.driverIds[0].toString(), this.props.params.claimId, claimRequest).subscribe(function (claim) {
            _this.setState({ claim: claim });
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], ClaimUpdatePagePlain.prototype, "supportPortalService", void 0);
    ClaimUpdatePagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ClaimUpdatePagePlain);
    return ClaimUpdatePagePlain;
}(React.Component));
exports.ClaimUpdatePagePlain = ClaimUpdatePagePlain;
exports.default = (0, components_1.withRouter)(ClaimUpdatePagePlain);
//# sourceMappingURL=ClaimUpdatePage.js.map